import React from 'react';
import { Button, FormControlLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import RefreshIcon from '@mui/icons-material/Refresh';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import SaleCalendarFilters from './SaleCalendarFilters';

import { useSaleCalendar } from './SaleCalendarContext';
import TransitionDaysModal from './modals/TransitionDaysModal';
import SlotsControlModal from './modals/SlotsControlModal';
import Iconify from '../../../components/Iconify';
import SaleCalendarReportModal from './modals/SaleCalendarReportModal';
import { useApp } from '../../../AppContext';

export default function SaleCalendarExtendedToolbar () {
  const { setSaleCalendarViewData } = useApp();
  const { selectedResort, setSelectedResort, submitSaleCalendar, isSaving, queryCalendar } = useSaleCalendar();
  const [showTransitionDaysModal, setShowTransitionDaysModal] = React.useState(false);
  const [showSaleCalendarReport, setShowSaleCalendarReportModal] = React.useState(false);
  const [showSlotsControlModal, setShowSlotsControlModal] = React.useState(false);
  const [showFilters, setShowFilters] = React.useState(false);

  const handleResortChange = e => {
    setSelectedResort(e.target.value);
    setSaleCalendarViewData(prev => ({ ...prev, resort: e.target.value }));
  };

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack direction="row" spacing={2} alignItems="center">
        <RadioGroup
          sx={{ ml: 1 }}
          row
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={selectedResort}
          onChange={e => handleResortChange(e)}
        >
          <FormControlLabel value={'giewartów'} control={<Radio />} label="Giewartów" />
          <FormControlLabel value={'mrówki'} control={<Radio />} label="Mrówki" />
        </RadioGroup>
        <Stack direction="column" spacing={1}>
          <Button
            fullWidth
            variant="contained"
            endIcon={<SaveIcon />}
            onClick={() => submitSaleCalendar()}
            disabled={isSaving}
          >
        Zapisz
          </Button>
          <Button
            fullWidth
            variant="contained"
            endIcon={<RefreshIcon />}
            onClick={() => queryCalendar()}
            disabled={isSaving}
          >
        Odśwież
          </Button>
        </Stack>
        <Button
          fullWidth
          variant="contained"
          endIcon={<Iconify icon={'ri:file-excel-2-fill'}/>}
          onClick={() => setShowSaleCalendarReportModal(true)}
          disabled={isSaving}
        >
        Wygeneruj raport...
        </Button>
        <Button
          fullWidth
          variant="contained"
          endIcon={<CalendarViewMonthIcon />}
          onClick={() => setShowTransitionDaysModal(true)}
          disabled={isSaving}
        >
        Ustaw dni przejściowe...
        </Button>
        <Button
          fullWidth
          variant="contained"
          endIcon={<CalendarViewMonthIcon />}
          onClick={() => setShowSlotsControlModal(true)}
          disabled={isSaving}
        >
        Ustaw kontrolę miejsc...
        </Button>
      </Stack>
      <Typography color={selectedResort == 'giewartów' ? 'secondary' : 'purple'} variant="h6">{selectedResort.toUpperCase()}</Typography>
      <SaleCalendarFilters
        open={showFilters}
        onClose={() => setShowFilters(false)}
      />
      <TransitionDaysModal open={showTransitionDaysModal} handleClose={() => setShowTransitionDaysModal(false)} />
      <SlotsControlModal open={showSlotsControlModal} handleClose={() => setShowSlotsControlModal(false)} />
      <SaleCalendarReportModal open={showSaleCalendarReport} handleClose={() => setShowSaleCalendarReportModal(false)} />
    </Stack>
  );
}
